import React from 'react';
import ConfirmationModal from '../../../../components/modals/ConfirmationModalNew';

const LocationsBulkStatusUpdateConfirmation = ({
	onCancel,
	handleStatusChangeAction,
	selectedAction,
	professionals
}) => {
	const actionLabel = selectedAction === 'ENABLE' ? 'Enable' : 'Disable';
	const title = `${actionLabel} the selected professionals at this location?`;

	const updateConfirmLabel = `${actionLabel} (${professionals.length}) selected professionals`;

	return (
		<ConfirmationModal
			size="l"
			className="enable-location-confirmation-modal"
			cancelLabel="Cancel"
			title={title}
			onCancel={onCancel}
			onConfirm={handleStatusChangeAction}
			confirmLabel={updateConfirmLabel}
		>
			{selectedAction === 'ENABLE' ? (
				<div>
					This will set {professionals.length} professionals as <b>enabled</b> at this location. Enabled professionals
					can fill shifts at locations where they are enabled. Please make sure you have selected the correct location
					before continuing.
				</div>
			) : (
				<div>
					This will set {professionals.length} professionals as <b>disabled</b> at this location. Disabled professionals{' '}
					<b>cannot</b> fill shifts at locations where they are disabled. Please make sure you have selected the correct
					location before continuing.
				</div>
			)}
		</ConfirmationModal>
	);
};

export default LocationsBulkStatusUpdateConfirmation;
